import { useFormikContext } from "formik";
import React from "react";
import FormFieldError from "./FormFieldError";

interface Props {
    name: string;
}

const FormikFieldError = ({ name }: Props) => {
    const { touched, errors } = useFormikContext<GenericObject>();

    return touched[name] && errors[name] ? <FormFieldError>{errors[name] as string}</FormFieldError> : null;
};

export default FormikFieldError;
